const boolean = (value: string): boolean => value === 'true';
const string = (value: string): string => String(value);

export default {
  boolean,
  string,
};
